import { render, staticRenderFns } from "./CategoriesConfiguration.vue?vue&type=template&id=1b17722c&scoped=true&"
import script from "./CategoriesConfiguration.vue?vue&type=script&lang=js&"
export * from "./CategoriesConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesConfiguration.vue?vue&type=style&index=0&id=1b17722c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17722c",
  null
  
)

export default component.exports